import { applyMergeFields } from "./templates.ts";

export const NEW_LEAD_SEQUENCE_NAME = "New lead follow-up";

export type SequenceStepInput = {
  id: number | string;
  day_offset: number;
  position: number;
  subject?: string | null;
  body: string;
};

export type PlannedSequenceEmail = {
  stepId: number | string;
  subject: string | null;
  body: string;
  sendNow: boolean;
  scheduledAt: string;
};

/** Day offsets are counted from enrollment. Day 0 sends immediately. */
export function plannedSequenceEmails(input: {
  steps: SequenceStepInput[];
  startedAt: string;
  firstName?: string | null;
  lastName?: string | null;
  repName: string;
  propertyAddress?: string | null;
}): PlannedSequenceEmail[] {
  const started = new Date(input.startedAt);
  const values = {
    first_name: input.firstName,
    last_name: input.lastName,
    rep_name: input.repName,
    property_address: input.propertyAddress,
  };
  return [...input.steps]
    .sort((a, b) => a.position - b.position || a.day_offset - b.day_offset)
    .map((step) => {
      const when = new Date(started);
      when.setDate(when.getDate() + step.day_offset);
      return {
        stepId: step.id,
        subject: step.subject ? applyMergeFields(step.subject, values) : null,
        body: applyMergeFields(step.body, values),
        sendNow: when.getTime() <= started.getTime(),
        scheduledAt: when.toISOString(),
      };
    });
}
